import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "@nuxtjs/composition-api";

interface Props {
    stepsCount: number,
    currentStep: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    stepsCount: { default: 1 },
    currentStep: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { stepsCount: number, currentStep: number };



const {
    stepsCount,
    currentStep,
} = toRefs(props);

const stepClass = (step: number) => {
    return step < currentStep.value ? 'step-done' : step === currentStep.value ? 'step-progress' : '';
}


return { __sfc: true,props, stepsCount, currentStep, stepClass }
}

})